import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: ${(props) => props.width};
  background: ${(props) =>
    props.title === 'light' || props.login
      ? props.theme.colors.lightgrey
      : props.theme.colors.darker};
  color: ${(props) => props.theme.colors.label};
  font-size: 12px;
  border-radius: 10px;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  margin: 15px 15px 15px 0;
  ${(props) => props.focused && `border-color: ${props.theme.colors.darkblue}`};
  ${(props) => props.height && `height: ${props.height}`};
  ${(props) => props.disabled && `cursor: not-allowed`};
  border: ${(props) => props.errorMessage};
  max-width: 450px;
  overflow: hidden;
`;

export const Input = styled.input`
  width: 100%;
  height: ${(props) => props.height || '60px'};
  font-size: 12px;
  margin: 0 15px 0 0;
  color: ${({ theme }) => theme.colors.darker};
  :disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
  background: ${(props) =>
    props.title === 'light' || props.login
      ? props.theme.colors.lightgrey
      : props.theme.colors.darker};

  &::placeholder {
    color: ${({ theme }) => theme.colors.label};
  }
  max-width: 450px;
`;

export const Icon = styled.img`
  width: ${(props) => (props.size ? props.size : '30px')};
  height: ${(props) => (props.size ? props.size : '30px')};
  margin: 15px;
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px;
  color: ${(props) => props.theme.colors.label};
  flex-shrink: 0;
`;

export const EyeButton = styled.button`
  cursor: pointer;
  background: transparent;
  animation: all 0.1s ease-in-out;
  font-size: 0;
  padding: 0 15px;
  height: 100%;

  img {
    margin: 0 !important;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;
